import { EntityDrawerProps, FCC, FormDrawer, FormDrawerContent, TextField } from "@dgs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { CountrySelectField } from "../../../../shared/ui/CountrySelectField";
import { AddressTypeSelect } from "../../contacts/selects/AddressTypeSelectField";
import { AddressFormState } from "../../shared/types";

export const ContactAddressDrawer: FCC<EntityDrawerProps<AddressFormState>> = ({ children, ...props }) => {
	const { t } = useTranslation();

	const validate = useCallback(
		(values: AddressFormState) => {
			const errors: { [K in keyof AddressFormState]?: any } = {};

			if (!values.street) {
				errors.street = t("Required field");
			}
			if (!values.houseNumber) {
				errors.houseNumber = t("Required field");
			}
			if (!values.zip) {
				errors.zip = t("Required field");
			}
			if (!values.city) {
				errors.city = t("Required field");
			}
			if (!values.country) {
				errors.country = t("Required field");
			}
			return errors;
		},
		[t],
	);

	return (
		<FormDrawer
			{...props}
			validate={validate}
			renderForm={(props) => (
				<FormDrawerContent {...props}>
					<TextField name="additionalInfo" label={t("Additional info")} />
					<TextField name="street" label={t("Street")} required />
					<TextField name="houseNumber" label={t("House number")} required />
					<TextField name="zip" label={t("Zip")} required />
					<TextField name="city" label={t("City")} required />
					<CountrySelectField name="country" label={t("Country")} required />
					<AddressTypeSelect name="type" label={t("Type")} />
					{children}
				</FormDrawerContent>
			)}
		/>
	);
};
